import useModals from '../../hooks/useModals'
import RateAndCeiling from '../../components/_social/payrollSimulator/RateAndCeiling';
import Simulator from '../../components/_social/payrollSimulator/Simulator';
import { useNavigate } from 'react-router-dom';
import { useUserContext } from '../../contexts/userContext';
import { useSocialStore } from '../../stores/social';
import { postPayrollSimulator } from '../../api/payroll';
import { showToastError } from '../../services/toast';
import { useState } from 'react';
import {
  ActionButton,
  CloseButton,
  PageHeader,
  PagePanel,
  PageShell,
  PanelToolbar,
  ToolbarRow,
} from '../../components/ui/page/PageShell';

const PayrollSimulator = () => {

  // Modals
  const { modals, openModals, openModal, closeModal } = useModals();
  const { typeRole } = useUserContext();
  const { formDataSimulator, setFormDataSimulator} = useSocialStore();
  const navigate = useNavigate();
  const [isExporting, setIsExporting] = useState(false);

  const handleExport = () => {
    setIsExporting(true);
    postPayrollSimulator(formDataSimulator)
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const a = document.createElement("a");
        a.href = url;
        a.download = "simulateur_de_paie.pdf";
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch((err) => {
        showToastError(err.response?.data?.message || 'Erreur lors de l\'exportation');
      })
      .finally(() => {
        setIsExporting(false);
      });
  }
  
  return (
    <PageShell>
      {/* Affichage des modales en fonction de openModals */}
      {Object.keys(modals).map((modalId) =>
        openModals[modalId] ? <div key={modalId}>{modals[modalId]}</div> : null
      )}

      <PageHeader
        eyebrow="Social"
        title="Simulateur de paie"
        actions={
          <>
            <ActionButton
              variant="primary"
              onClick={handleExport}
              disabled={isExporting}
              icon={
                isExporting ? (
                  <span
                    aria-hidden="true"
                    className="size-4 animate-spin rounded-full border-2 border-white/40 border-t-white"
                  />
                ) : undefined
              }
            >
              {isExporting ? 'Export...' : 'Export'}
            </ActionButton>
            <CloseButton
              label="Fermer le simulateur"
              onClick={() => {
                if(typeRole === "Company") {
                  navigate("/social")
                } else {
                  navigate("/customer-area/social")
                }
              }}
            />
          </>
        }
      />

      <PagePanel>
        <PanelToolbar>
          <ToolbarRow>
            <div className="flex flex-wrap items-center gap-2">
              <ActionButton
                onClick={() => {
                  openModal(
                    "rateAndCeiling",
                    <RateAndCeiling closeModal={() => closeModal("rateAndCeiling")} />
                  );
                }}
              >
                Taux &amp; plafonds
              </ActionButton>
              <ActionButton
                onClick={() => {
                  setFormDataSimulator({});
                }}
              >
                Réinitialiser
              </ActionButton>
            </div>
          </ToolbarRow>
        </PanelToolbar>

        <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
          <Simulator />
        </div>
      </PagePanel>
    </PageShell>
  )
}

export default PayrollSimulator;
